import React, {useEffect, useState} from "react";
import FilteringAccordionItem from "../../atoms/filtering-accordion-item/filtering-accordion-item";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../../../store/configureStore";
import {Config} from "../../../../constants/Config";
import {clubFinderSearchBarSliceActions} from "../../../../store/slices/clubFinderSearchBarSlice";

const GenderFilterComponent = (props: any): JSX.Element => {
  const dispatch = useDispatch();

  const genderOptions: any = props.genderFilterOptions ? [ Config.defaultGenderOption, ...props.genderFilterOptions] : [Config.defaultGenderOption]
  const activeSearchFilter: any = useSelector((state: RootState) => state.clubFinderSearchBarStore.activeSearchFilterMobile);
  const selectedGenderFilter: {type: string, name: string}[] | null = useSelector((state: RootState) => state.clubFinderSearchBarStore.selectedMultiGenderFilters);
  const [genderOptionsSaved, setSavedGender] = useState<{type: string, name: string}[] | null>()

  useEffect(() => {
    if (selectedGenderFilter) {
      setSavedGender([...selectedGenderFilter])
    } else {
      setSavedGender(null)
    }
  }, [activeSearchFilter, selectedGenderFilter])

  const saveGenderOption = (genderOption: any) => {
    if (selectedGenderFilter) {
      const tempSelectedGenderFilters = [...selectedGenderFilter]

      const index = tempSelectedGenderFilters.findIndex(item => item.type === genderOption.type);

      if (index !== -1) {
        tempSelectedGenderFilters.splice(index, 1);
        setSavedGender([...tempSelectedGenderFilters]);
        dispatch(clubFinderSearchBarSliceActions.setSavedMultiGenderFilter([...tempSelectedGenderFilters]));
      } else {
        tempSelectedGenderFilters.push(genderOption);
        setSavedGender([...tempSelectedGenderFilters]);
        dispatch(clubFinderSearchBarSliceActions.setSavedMultiGenderFilter([...tempSelectedGenderFilters]));
      }
    } else {
      setSavedGender([genderOption]);
      dispatch(clubFinderSearchBarSliceActions.setSavedMultiGenderFilter([genderOption]));
    }
  }

  return (
    <FilteringAccordionItem accordionTitle={'Gender'} filterOption={genderOptions} filterType={'gender'}
                            key={'gender'}
                            handleOptionSelections={(genderOption: any) => saveGenderOption(genderOption)} selectedGenderOption={genderOptionsSaved}/>
  )
}

export default GenderFilterComponent;
